import React, { useEffect, useState } from "react";
import { Button, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";

import rutaLogo from "../assets/images/ruta40-logo.svg";
import backArrow from "../assets/images/backArrow.svg";

import * as Common from "../commons/common";
import * as Utils from "../utils/utils";

import styles from "./PageHeader.module.css";

export type TypeHeader = {
    leftType?: string;
    title?: string;
    rightType?: string;
};

function PageHeader({ headerType }: { headerType?: TypeHeader }) {
    const navigate = useNavigate();
    const params = useParams();

    const handleBackClick = () => {
        if (headerType?.title === "예약 상세보기" && location.href.includes("#")) {
            navigate(Common.PAGE_MAIN);
        } else if (params.manualContent) {
            navigate(Common.PAGE_MANUAL);
        } else {
            navigate(-1);
        }
    };

    const [currentHeaderType, setCurrentHeaderType] = useState(headerType);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_SET_HEADER_TITLE, setHeaderTitle);

        return () => {
            Utils.offEvent(Common.EVENT_SET_HEADER_TITLE, setHeaderTitle);
        };
    }, []);

    const setHeaderTitle = (data: CustomEvent) => {
        // setCurrentHeaderType({ ...currentHeaderType, title: data.detail });
    };

    return (
        <Row className={styles.wrapper} justify={headerType?.leftType === "logo" ? "space-between" : "center"}>
            {headerType?.leftType === "logo" ? (
                <div className={styles.logo}>
                    <img className={styles.logoImg} src={rutaLogo} height={34} />
                </div>
            ) : headerType?.leftType === "none" ? (
                ""
            ) : (
                <div className={styles.back}>
                    <Button type="text" onClick={handleBackClick}>
                        <img src={backArrow} alt="backarrow for going back in history" />
                    </Button>
                </div>
            )}

            <p className={styles.headerText}>{headerType?.title}</p>
        </Row>
    );
}

export default PageHeader;
